import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/Users/";
const enrollmentUrl = process.env.API_URL + "/Enrollment/";

export function validateEnrollment(code, brandIdentifier) {
  return apiUtils
    .get(
      `${enrollmentUrl}ValidateCode/` +
        code +
        `?BrandIdentifier=${brandIdentifier}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function validateMailer(code) {
  return apiUtils
    .get(`${enrollmentUrl}ValidateMailer/` + code)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateMailer(mailerObj) {
  return apiUtils
    .post(`${enrollmentUrl}UpdateMailer`, mailerObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function enrolleeRegister(enrolleeObj) {
  let webUserName = {webUserName: 'ClientPortal'};
  let newEnrolleeObj = {...enrolleeObj,...webUserName};
  return apiUtils
    .post(`${baseUrl}EnrolleeRegister`, newEnrolleeObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function verifyEmail(emailObj) {
  return apiUtils
    .post(`${baseUrl}ResetCodeEmail`, emailObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function verifyText(emailObj) {
  return apiUtils
    .post(`${baseUrl}ResetCode`, emailObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function verifyEnrollee(verifyObj) {
  return apiUtils
    .post(`${baseUrl}EnrolleeVerify`, verifyObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function validateReCaptcha(gToken) {
  return apiUtils
    .get(`${enrollmentUrl}ValidateReCaptcha?Token=` + gToken)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function resetProfilePassword(userID, password) {
  return apiUtils
    .post(`${baseUrl}ResetUserPassword`, { userID, password })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function authenticate(UserName, password) {
  return apiUtils
    .post(`${baseUrl}authenticate`, { UserName, password })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getCountyList(RegionId, Type, BrandIdentifier) {
  let typeAddOn = Type === undefined ? "" : "?Type=" + Type;
  let BrandIdentifierAddOn = "";
  if (BrandIdentifier !== undefined) {
    if (typeAddOn === "") {
      BrandIdentifierAddOn = "?BrandIdentifier=" + BrandIdentifier;
    } else {
      BrandIdentifierAddOn = "&BrandIdentifier=" + BrandIdentifier;
    }
  }
  return apiUtils
    .get(
      `${enrollmentUrl}GetCounties/${RegionId}${typeAddOn}${BrandIdentifierAddOn}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function validateSecureLink(verifyObj) {
  return apiUtils
    .post(`${baseUrl}ValidateSecureLink`, verifyObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function expireSecureLink(expireObj) {
  return apiUtils
    .post(`${baseUrl}ExpireSecureLink`, expireObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}


export function getUser(userId)
{
 return apiUtils
    .get(`${baseUrl}${userId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}